"use strict";
// _partialFile.js

{
  let privacyOpened = false;
  $(".p-form__acceptance-agree a").on("click", function () {
    privacyOpened = true;
    checkForm(); // 状態が変わったので再チェック
  });

  function checkForm() {
    let allFilled = true;

    // 必須項目だけをチェック
    $("#contact-form input[required]").each(function () {
      if (!$(this).val()) {
        allFilled = false;
        return false;
      }
    });

    // プライバシーポリシーを開いていなければNG
    if (!privacyOpened) {
      allFilled = false;
    }

    if (allFilled) {
      $("#button")
        .prop("disabled", false)
        .css("background-color", "#F18900")
        .css("color", "#fff")
        .css("cursor", "pointer");
      $(".p-form__submit").removeClass("is-disabled");
    } else {
      $("#button")
        .prop("disabled", true)
        .css("background-color", "#ccc")
        .css("color", "#fff")
        .css("cursor", "not-allowed");
      $(".p-form__submit").addClass("is-disabled");
    }
  }

  // 入力・選択のたびにチェック
  $(
    "#contact-form input[required]"
  ).on("input change", checkForm);

  // ページ読み込み時にも初期チェック
  $(document).ready(checkForm);
}
